<template>
    <div>
        <v-dialog class="free-bet" fullscreen persistent v-model="isShowModal" width="100%">
            <v-card>
                <LoadingScreen v-if="isLoading" />
                <div v-else class="free-bet__box-modal">
                    <div class="free-bet__close" @click="onCloseModal">
                        <img src="~ThemePath/images/close-green.png" alt="close" />
                    </div>
                    <div class="free-bet__empty-game" v-if="isEmptyGame">
                        <span class="free-bet__empty-game--text">
                            {{ getTranslatedText('This game is not supported') }}
                        </span>
                    </div>

                    <template v-else>
                        <h2 class="free-bet__title">
                            {{
                                getTranslatedText('FREE BET [ticket]', {
                                    ticket: dataFreeBet.bet_slip_id,
                                })
                            }}
                        </h2>
                        <h2 class="free-bet__title">
                            {{ getTranslatedText(setupGame.GAME_NAME) }}
                        </h2>
                        <p class="free-bet__description">
                            {{
                                getTranslatedText('you have [number] free bet tickets', {
                                    number: dataFreeBet?.free_bet_count || 0,
                                })
                            }}
                        </p>
                        <div
                            v-for="I_EVENT in configGameAndEvent.eventInfo"
                            :key="I_EVENT.event_id"
                            class="free-bet__events-list"
                            :class="setupGame.EVENT_CLASS_NAME"
                        >
                            <div class="free-bet__events-items">
                                <span class="free-bet__events-items--title">
                                    {{ renderDayOfWeek(I_EVENT.draw_date) }} {{ renderDate(I_EVENT.draw_date) }}
                                </span>
                            </div>
                        </div>
                        <component :is="nameComponentRender" :is-free-bet="true" @on-select-number="onSelectNumber" />
                        <div class="free-bet__box-action">
                            <div class="free-bet__box-action--cart" :class="{ 'no-cart': cart.length === 0 }">
                                <div
                                    v-for="(I_CART, IX_CART) in cart"
                                    :key="IX_CART"
                                    class="free-bet__box-action--cart-item"
                                >
                                    <div class="free-bet__box-action--cart-item--number">
                                        <span
                                            v-for="(I_NUMBER, IX_NUMBER) in I_CART.selectNumber"
                                            :key="IX_NUMBER"
                                            class="free-bet__box-action--cart-item--number-item"
                                        >
                                            {{ I_NUMBER }}
                                            <span v-if="IX_NUMBER < I_CART.selectNumber.length - 1">, </span>
                                        </span>
                                    </div>
                                    <span class="free-bet__box-action--cart-item--price">
                                        {{ renderPrice(dataFreeBet.free_bet_wager) }}
                                    </span>
                                    <div class="free-bet__box-action--cart-item--action" @click="onRemoveItem(IX_CART)">
                                        <img src="~ThemePath/images/close.png" alt="close" />
                                    </div>
                                </div>
                                <span v-if="cart.length === 0" class="free-bet__no-data">
                                    {{ getTranslatedText('No Data') }}
                                </span>
                            </div>
                            <div class="free-bet__box-action--cart-action">
                                <div class="free-bet__box-action--cart-action-item">
                                    <ButtonCommon
                                        value="Add"
                                        :isNoHover="true"
                                        :isLoading="false"
                                        :isDisable="freeBetCount <= 0 || isLoadingButton"
                                        @on-click-button-common="onAddToCart"
                                    />

                                    <ButtonCommon
                                        :isNoHover="true"
                                        :isLoading="false"
                                        :value="getTranslatedText('Add x[count]', { count: freeBetCount })"
                                        :isDisable="freeBetCount <= 0 || isLoadingButton"
                                        @on-click-button-common="onAddToCart(true)"
                                    />
                                </div>
                                <div class="free-bet__box-action--cart-action-item">
                                    <ButtonCommon
                                        type="active"
                                        :isNoHover="true"
                                        :isLoading="isLoadingButton"
                                        :isDisable="freeBetCount > 0"
                                        value="ClaimFree Ticket"
                                        @on-click-button-common="onSubmitTransact"
                                    />
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </v-card>
        </v-dialog>
        <ReprintDialog @close-popup-reprint="onCloseModalReprint"/>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import printMixin from '@/mixins/print/print-mixin'
import gamesService from '@/services/games.service'
import BetslipsService from '@/services/betslip.service'

import Numbers545 from '@/views/loto-545/numbers.vue'
import ButtonCommon from '@/components/common/button/index.vue'
import LoadingScreen from '@/components/common/loading/index.vue'
import ReprintDialog from '@/components/common/dialog/reprint.vue'
import EventBus from '@/utils/EventBus'

import { formatDateUTC00, formatPrice, getDayOfWeek, isArrayEmpty, isStrEmpty } from '@/utils/utils'
import { CT_LOTTO_545 } from '@/constants/lotto'
import { getToken } from '@/services/axios'

const CT_DEFAULT_RENDER_EVENT = 1

export default {
    components: { [CT_LOTTO_545.NAME_OF_COMPONENT]: Numbers545, ButtonCommon, ReprintDialog, LoadingScreen },
    mixins: [languageMixins, printMixin],

    props: {
        isShowModal: {
            type: Boolean,
            default: false,
        },
        dataFreeBet: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isLoading: true,
            isLoadingButton: false,
            isEmptyGame: false,
            nameComponentRender: '',
            freeBetCount: 1,
            selectNumber: [],
            dataFirstDraw: {},
            configGameAndEvent: {},
            setupGame: {},
            cart: [],
        }
    },
    created() {
        this.freeBetCount = this.dataFreeBet?.free_bet_count || 0
        this.callApiBySlug(this.dataFreeBet.free_bet_game_slug)
    },
    methods: {
        async callApiBySlug(slug) {
            const strategies = {
                [CT_LOTTO_545.SLUG]: this.getGamesAndDraws(CT_LOTTO_545),
            }

            if (strategies[slug]) {
                return await strategies[slug]
            }

            this.isEmptyGame = true
            this.isLoading = false
        },

        async getGamesAndDraws(CONFIG) {
            const { API_URL_TYPE, LOCAL_STORAGE_KEY_EVENTS: local_key_event, NAME_OF_COMPONENT } = CONFIG
            try {
                const resp = await gamesService.getListGames(API_URL_TYPE)
                const respEvent = await gamesService.getListEvents(API_URL_TYPE)

                if (!isArrayEmpty(resp.data) && !isArrayEmpty(respEvent.data)) {
                    const indexGames = resp.data.findIndex((x) => x.game.slug === CT_LOTTO_545.SLUG)
                    const dataGames = resp.data[indexGames]

                    const dataEvents = respEvent.data.filter((x) => x.game.toLowerCase() === CT_LOTTO_545.GAME_NAME)

                    const lengthEventSelect = CT_DEFAULT_RENDER_EVENT

                    this.renderParamEvent({ dataGames, dataEvents, lengthEventSelect, local_key_event })

                    this.nameComponentRender = NAME_OF_COMPONENT
                    this.setupGame = CONFIG
                    this.dataFirstDraw = dataEvents[0]
                    this.dataFirstGames = dataGames
                } else {
                    this.isEmptyGame = true
                }
            } catch (error) {
                console.log(error)
            } finally {
                this.isLoading = false
            }
        },

        renderDataNextEvent({ events, lengthEventSelect }) {
            let event_id = []
            let eventInfo = []
            if (!isArrayEmpty(events) && lengthEventSelect > 0) {
                eventInfo = events.slice(0, lengthEventSelect)
                event_id = eventInfo.map((item) => item.event_id)
            }
            return {
                event_id,
                eventInfo,
            }
        },

        renderParamEvent({ dataGames, dataEvents, lengthEventSelect, local_key_event }) {
            const maxPicks = dataGames.game?.config?.setup[1].maxPicks
            const minPicks = dataGames.game?.config?.setup[1].picks

            const { event_id, eventInfo } = this.renderDataNextEvent({ events: dataEvents, lengthEventSelect })

            let param = {
                title: dataGames.game?.name,
                game: dataGames.game?.slug,
                gameNumber: dataGames.game?.game_id,
                maxPicks: maxPicks,
                minPicks: minPicks,
                numberQp: minPicks,
                event_id,
                eventInfo,
                selection: [],
                draws: 1,
                wager: dataGames.game?.price,
                isPariMutuelLotto: true,
                gameType: dataGames.game.slug,
            }

            if (dataGames.game?.estimated_jackpot) {
                param['estimated_jackpot'] = dataGames.game?.estimated_jackpot
            }
            this.configGameAndEvent = param
            localStorage.setItem(local_key_event, JSON.stringify(param))
        },

        // handle number
        onSelectNumber(select) {
            this.selectNumber = select
        },

        onRemoveItem(index) {
            this.cart.splice(index, 1)
            this.freeBetCount += 1
        },

        onAddToCart(isMultiAddBet = false) {
            if (this.configGameAndEvent.minPicks > this.selectNumber.length) {
                const param = {
                    text: this.getTranslatedText(`Please make sure that you select [number] of balls!`, {
                        number: this.configGameAndEvent.minPicks,
                    }),
                    type: 'warning',
                }
                EventBus.$emit('show-notications', param)

                return false
            }

            const multiAddBet = isMultiAddBet ? this.freeBetCount : 1

            const newItems = Array.from({ length: multiAddBet }, () => ({
                selectNumber: [...this.selectNumber],
            }))

            this.cart.push(...newItems)
            this.freeBetCount -= multiAddBet
            EventBus.$emit('on-clear-select-number')
        },

        renderBodySubmitCart() {
            const body = []

            this.cart.forEach((element) => {
                const item = {
                    draws: 1,
                    event_id: this.configGameAndEvent.event_id,
                    game: this.configGameAndEvent.game,
                    selection: [element.selectNumber],
                    wager: this.dataFreeBet.free_bet_wager,
                }
                body.push(item)
            })

            return body
        },

        async onSubmitTransact() {
            try {
                this.isLoadingButton = true
                const bet_timestamp = new Date().getTime() / 1000
                const token = getToken()
                if (!isStrEmpty(token)) {
                    const respCheckDevice = await BetslipsService.deviceBindingcheck()
                    if (respCheckDevice.status === 200) {
                        const body = this.renderBodySubmitCart()
                        const resp = await BetslipsService.transactLotto(
                            body,
                            bet_timestamp,
                            this.setupGame.API_URL_TYPE,
                            '',
                            this.dataFreeBet.bet_slip_id
                        )

                        if (resp.code === 200) {
                            let paramPrint = null

                            let dataEntries = resp.data.bets.entries.map((x) => {
                                const drawName = this.getTranslatedText(x.game.game)

                                let item = {
                                    ...x,
                                }
                                item.game['game'] = this.getTranslatedText(x.game.game)
                                item.event['drawName'] = drawName

                                const isLotto545 = this.dataFreeBet.free_bet_game_slug === CT_LOTTO_545.SLUG

                                if (isLotto545) {
                                    if (x.entry.bet[0].length > this.configGameAndEvent.maxPicks) {
                                        item['combinations'] = generateCombinations(
                                            Number(x.entry.bet[0].length),
                                            Number(this.configGameAndEvent.maxPicks)
                                        )
                                        item['type'] = `${this.getTranslatedText('multiplePrint')}${
                                            x.entry.bet[0].length
                                        }`
                                    } else {
                                        item['type'] = `${this.getTranslatedText('simple')}`
                                        item['combinations'] = 1
                                    }

                                    if (this.dataFirstDraw.event_id == item.event.eventId) {
                                        item.game.jackpot = this.configGameAndEvent?.estimated_jackpot || 1
                                    }
                                }

                                return item
                            })

                            resp.data.bets['entries'] = dataEntries
                            resp.data['isCombinations'] = this.setupGame.IS_COMBINATIONS
                            paramPrint = resp.data

                            this.showReprintDialog(resp?.data?.transaction, paramPrint)

                            this.printLoto(paramPrint)
                            this.cart = []

                            parent.postMessage({ command: 'print-rebet-ticket', param: paramPrint }, '*')
                        } else {
                            this.onShowToast('error', resp.message, 400)
                        }
                    } else {
                        this.onShowToast('error', resp.message, 400)
                    }
                }
            } catch (error) {
                this.onShowToast(
                    'error',
                    error === 'ECONNABORTED'
                        ? this.getTranslatedText('Request timeout. Please check your network connection.')
                        : error,
                    401
                )
            } finally {
                this.isLoadingButton = false
            }
        },

        showReprintDialog(transaction, paramPrint) {
            let betslipId = transaction?.externalId ?? transaction?.external_id ?? ''
            EventBus.$emit('on-show-reprint', {
                ticketType: 'L',
                reference: transaction?.reference,
                betslipId: betslipId.startsWith('L-') ? betslipId : 'L-' + betslipId,
                paramPrint: paramPrint,
                forLotto: true,
            })
        },

        onShowToast(title, message) {
            const param = {
                title: title,
                description: message,
                isShowCancel: false,
                nameFunction: 'hideModal',
            }
            EventBus.$emit('on-show-dialog', param)
        },

        onCloseModal() {
            this.$emit('on-close-modal')
        },

        onCloseModalReprint() {
            if(this.freeBetCount <= 0) {
                this.$emit('on-reload-data')
                this.$emit('on-close-modal')
            }
        },

        // utils
        renderPrice(price) {
            return formatPrice(price)
        },

        renderDate(date) {
            const dateFormat = formatDateUTC00(date)

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}H${dateFormat.minutes}`

            return valueDate
        },

        renderDayOfWeek(drawDate) {
            const dayOfWeek = getDayOfWeek(drawDate)
            return this.getTranslatedText(dayOfWeek)
        },
    },
}
</script>

<style lang="scss" scoped>
.free-bet__box-modal {
    position: relative;
    padding: 30px 10px 20px 10px;
    .free-bet__close {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }

    .free-bet__title {
        color: var(--text_main_color);
        font-size: 20px;
        font-weight: bold;
        text-transform: uppercase;
        text-align: center;
        margin-bottom: 10px;
    }

    .free-bet__description {
        color: var(--text_main_color);
        font-size: var(--fontSize);
        font-weight: bold;
        text-transform: uppercase;
        text-align: center;
        margin-bottom: 10px;
    }

    .free-bet__empty-game {
        padding-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .free-bet__empty-game--text {
        font-size: calc(var(--fontSize) + 6px);
        font-weight: bold;
        text-transform: uppercase;
        color: var(--text_main_color);
    }

    .free-bet__events-list {
        display: grid;
        gap: 4px;
        &.lotto545 {
            background-color: var(--color-bg-game-lotto-545);
        }
    }

    .free-bet__events-items {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-flow: column;
        row-gap: 2px;
        padding: 6px 0;
        color: var(--colorText2);
        cursor: pointer;
    }

    .free-bet__events-items--title {
        font-size: var(--fontSize);
        font-weight: bold;
    }

    .free-bet__box-action--cart {
        display: flex;
        flex-flow: column;
        gap: 5px;
        border-radius: var(--borderRadius);
        padding: 7px 6px;
        background-color: var(--color-bg-number-price);
        color: var(--colorText2);
        &.no-cart {
            opacity: 0.6;
        }
    }

    .free-bet__box-action--cart-item {
        display: grid;
        align-items: center;
        grid-template-columns: repeat(3, 1fr);
        font-size: var(--fontSize);
        &:not(:last-child) {
            border-bottom: 1px solid #1c6c25;
            padding: 5px 0;
        }
    }

    .free-bet__box-action--cart-item--price {
        text-align: center;
    }

    .free-bet__box-action--cart-item--action {
        text-align: right;
        img {
            width: 16px;
        }
    }

    .free-bet__box-action--cart-item--number {
        display: flex;
        flex-flow: wrap;
    }

    .free-bet__box-action--cart-action {
        display: flex;
        flex-flow: column;
        margin-top: 10px;
        gap: 5px;
    }

    .free-bet__box-action--cart-action-item {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 5px;
        .button {
            width: 100%;
        }
    }

    .free-bet__no-data {
        text-align: center;
        font-size: calc(var(--fontSize) + 2px);
    }
}
// @import '~ThemePath/scss/common/_empty.scss';
</style>
